import React, { useEffect, useState } from "react";
import { getLocalDate } from "../../utils/AppFunctions";
import { cancelIcon } from "../../assets/icons/SvgIconList";

interface IToastProps {
  type: "success" | "error" | "warning" | "info";
  message: string;
  duration: number;
}

const ICToast: React.FC<IToastProps> = ({ type, message, duration }) => {
  const [progress, setProgress] = useState(100);
  const [closed, setClosed] = useState(false);
  const [hovered, setHovered] = useState(false);
  const [hoverStart, setHoverStart] = useState<number | null>(null);
  const [totalRemainingSecond, setTotalRemainingSecond] = useState(duration);
  const [lastHoverTime, setLastHoverTime] = useState(getLocalDate().getTime());
  const getBackgroundColor = () => {
    switch (type) {
      case "success":
        return "#4caf50";
      case "error":
        return "red";
      case "warning":
        return "orange";
      case "info":
        return "#00000094";
      default:
        return "#4caf50";
    }
  };

  let srcImage = "";

  switch (type) {
    case "info":
      srcImage = "https://img.icons8.com/plumpy/24/info.png";
      break;
    case "success":
      srcImage = "https://img.icons8.com/color/48/000000/ok--v1.png";
      break;
    case "error":
      srcImage = "https://img.icons8.com/fluency/48/000000/high-importance.png";
      break;
    case "warning":
      srcImage = "https://img.icons8.com/color/48/000000/error--v1.png";
      break;
    default:
      srcImage = "https://img.icons8.com/color/48/000000/ok--v1.png";
      break;
  }

  const toastClasses = [
    "toast",
    `toast-${type.charAt(0).toUpperCase() + type.slice(1)}`,
  ];
  const toastStyles = {
    backgroundColor: "white",
    borderRadius: "3px",
    boxShadow: "rgba(99, 99, 99, 0.2) 0px 2px 8px 2px",
    width: "250px",
  };
  const [timer, setTimer] = useState<NodeJS.Timeout>();
  useEffect(() => {
    if (timer) {
      clearTimeout(timer);
    }
    if (hovered) {
      setTotalRemainingSecond(
        totalRemainingSecond - (getLocalDate().getTime() - lastHoverTime)
      );
    }

    if (!hovered) {
      setLastHoverTime(getLocalDate().getTime());
      const tempTimer: NodeJS.Timeout = setTimeout(() => {
        setClosed(true);
      }, totalRemainingSecond);
      setTimer(tempTimer);
    }
    if (duration && !closed) {
      if (!hovered) {
        const interval = 10;
        const increment = (100 / duration) * interval;

        const intervalId = setInterval(() => {
          setProgress((prevProgress) => prevProgress - increment);
        }, interval);
        return () => {
          clearInterval(intervalId);
        };
      }
    }
  }, [duration, closed, hovered]);

  useEffect(() => {
    if (!hoverStart) {
      const interval2 = setInterval(() => {}, 1000);
      return () => {
        clearInterval(interval2);
      };
    }
  }, [hoverStart]);
  const progressBarStyles = {
    width: `${progress}%`,
    backgroundColor: getBackgroundColor(),
    height: "4px",
  };

  const handleCloseClick = () => {
    setClosed(true);
  };

  if (closed) {
    return null;
  }
  const handleMouseEnter = () => {
    setHovered(true);

    setHoverStart(getLocalDate().getTime());
  };

  const handleMouseLeave = () => {
    setHovered(false);
    setHoverStart(null);
  };

  return (
    <div
      className={`pt-1 mb-2 border cursor-pointer rounded-2  ${toastClasses.join(
        " "
      )}`}
      style={toastStyles}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      <div className="px-2 pt-1 flex justify-end">
        <button type="button" onClick={handleCloseClick}>
          {cancelIcon}
        </button>
      </div>
      <div className="px-4 pb-3 flex items-center">
        <img width="23" height="23" src={srcImage} alt="ok--v1" />
        <p className="flex items-center px-2">{message}</p>
      </div>
      {!!duration && <div style={progressBarStyles}></div>}
    </div>
  );
};

export default ICToast;
